module.exports = __webpack_public_path__ + "img/symbol_7.ae549cf3.png";